import axiosIns from '@/libs/axios'
import toErrorResult from '@/store/helpers/errorResult'

const ROOT_URL = '/Admin/data/downloads'
const MEDIA_ERROR_MESSAGE = 'Dosya indirilemedi. Lütfen tekrar deneyin.'

// Blob olarak gelen hata yanıtını ({ message } JSON'u ya da düz metin) okunur mesaja çevirir
const readBlobMessage = async blob => {
  try {
    const text = await blob.text()
    try {
      return JSON.parse(text).message || MEDIA_ERROR_MESSAGE
    } catch (e) {
      return text || MEDIA_ERROR_MESSAGE
    }
  } catch (e) {
    return MEDIA_ERROR_MESSAGE
  }
}

// Content-Disposition: attachment; filename="baslik.png" (filename*=UTF-8'' biçimi de desteklenir)
const fileNameFromHeader = header => {
  if (!header) {
    return null
  }
  const encoded = header.match(/filename\*=UTF-8''([^;]+)/i)
  if (encoded) {
    return decodeURIComponent(encoded[1])
  }
  const plain = header.match(/filename="?([^";]+)"?/i)
  return plain ? plain[1] : null
}
export default {
  namespaced: true,
  state: {
    loading: false,
    dataResponse: {
      message: null,
      status: null,
      token: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataResponse(state) {
      return state.dataResponse
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_RESPONSE(state, data) {
      state.dataResponse = data
    },
    RESET_DATA_RESPONSE(state) {
      state.dataResponse = {
        message: null,
        status: null,
        token: null,
      }
    },
  },
  actions: {
    createDownload({ commit }, postData) {
      commit('SET_LOADING', true)
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/createDownload`, data)
        .then(response => {
          commit('SET_DATA_RESPONSE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    // Medya galeri indirmesi: tek kullanımlık token alır, dosyayı blob olarak indirir
    async downloadMedia(context, itemId) {
      const created = await axiosIns
        .post(`${ROOT_URL}/createDownload`, { component: 'media_gallery', item_id: itemId })
        .then(response => response.data)
        .catch(error => toErrorResult(error, MEDIA_ERROR_MESSAGE))
      if (!created || !created.token) {
        return { status: false, message: (created && created.message) || MEDIA_ERROR_MESSAGE }
      }
      try {
        const response = await axiosIns.post(`${ROOT_URL}?token=${created.token}`, {}, { responseType: 'blob' })
        const contentType = String(response.headers['content-type'] || '')
        // Backend hatayı JSON, geçersiz token'ı düz metin olarak 200 ile döndürebiliyor
        if (contentType.includes('application/json') || contentType.startsWith('text/')) {
          return { status: false, message: await readBlobMessage(response.data) }
        }
        return {
          status: true,
          blob: response.data,
          fileName: fileNameFromHeader(response.headers['content-disposition'])
            || `dosya.${(response.data.type.split('/')[1] || 'bin').split(';')[0]}`,
        }
      } catch (error) {
        console.error(error)
        const data = error.response && error.response.data
        return {
          status: false,
          message: data instanceof Blob ? await readBlobMessage(data) : MEDIA_ERROR_MESSAGE,
        }
      }
    },
    downloadFile({ commit }, postData) {
      return axiosIns
        .post(`${ROOT_URL}?token=${postData.token}`, {
          responseType: 'blob',
        })
        .then(response => response)
    },
  },
}
